export enum IndexDbKeys {
  LookupChecksum = 'LookupChecksum',
  ConfigChecksum = 'ConfigChecksum',
}

export interface SystemCheckSums {
  Key: IndexDbKeys;
  Value: string;
}

export class IndexDbData<T> {
  key!: IndexDbKeys;
  value!: T;
  checkSumValue?: string | null;
}
